import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  Card,
  Heading,
  Paragraph,
  Button,
  Table,
} from "ProtoType/Slack/styles/Common";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { SG_GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES } from "constants/actions";

const SlackAppSettings = ({ get_slack_scheduler }) => {
  const dispatch = useDispatch();
  const [groupMembers, setGroupMembers] = useState([]);

  function AddEmployee(id) {
    dispatch({
      type: SG_GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES,
      payload: {
        id: get_slack_scheduler?.organization_group,
        employee_ids: [id],
      },
    });
  }

  useEffect(() => {
    setGroupMembers(
      get_slack_scheduler?.organization_group_details?.organization_group_members
    );
  }, [dispatch, get_slack_scheduler]);

  return (
    <Card>
      <Heading>Enrolled Employees</Heading>
      <>
        <Paragraph></Paragraph>
        <Table>
          <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>First</th>
              <th>Last</th>
              <th>Email</th>
              <th>Emp Status</th>
              <th>Slack ID</th>
              <th>Slack Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {groupMembers &&
              groupMembers.map((user) => (
                <TableRow key={user.id} hasSlackId={!!user?.employee?.employee_slack?.slack_id}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{user?.employee?.id}</td>
                  <td>{user?.employee?.first_name}</td>
                  <td>{user?.employee?.last_name}</td>
                  <td>{user.employee?.email}</td>
                  <td>{user?.employee?.status ? "Active" : "Not Active"}</td>
                  <td>{user?.employee?.employee_slack?.slack_id ? user?.employee?.employee_slack?.slack_id : "Not Found"}</td>
                  <td>{user?.employee?.employee_slack?.slack_display_name ? user?.employee?.employee_slack?.slack_display_name : "Not Found"}</td>
                  <td>
                    <Button
                      style={{
                        background: "#FFF",
                        color: "#DC3545",
                        borderColor: "#DC3545",
                      }}
                      onClick={() => AddEmployee(user?.employee?.id)}
                    >
                      Remove
                    </Button>
                  </td>
                </TableRow>
              ))}
          </tbody>
        </Table>
      </>
    </Card>
  );
};

export default SlackAppSettings;

const TableRow = styled.tr`
  background-color: ${(props) => (props.hasSlackId ? "#d4edda" : "transparent")};
`;